import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextInputLimitCounter from './TextInputLimitCounter';

const Title = styled('h5')`
  float: left;
  cursor: default;
  margin: 0;
  padding: 0;
  font-size: 13px;
  line-height: 18px;
  display: block;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #373e44;
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
`;

const CounterContainer = styled('span')`
  float: right;
`;

export default class TextInputTitle extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { children, maxLength, currentLength } = this.props;

    let fieldCounter = null;

    return (
      <div>
        <Title>{children}</Title>
        <CounterContainer>
          {typeof maxLength !== 'undefined' && (
            <TextInputLimitCounter
              currentLength={currentLength}
              maxLength={maxLength}
            ></TextInputLimitCounter>
          )}
        </CounterContainer>
      </div>
    );
  }
}

TextInputTitle.defaultProps = {
  children: ''
};

TextInputTitle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  maxLength: PropTypes.number,
  maxLengthValue: PropTypes.string
};
